import { render, staticRenderFns } from "./RequestToBookButton.vue?vue&type=template&id=394debf6"
import script from "./RequestToBookButton.vue?vue&type=script&lang=js"
export * from "./RequestToBookButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports